export const Spinner = ({
  width = 46,
  height = 46,
  viewBox = "-1 -1 46 46",
  stroke = "#2D2D2D",
  strokeWidth = "3",
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
    className="oval"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)" strokeWidth={strokeWidth}>
        <circle strokeOpacity=".2" cx="18" cy="18" r="18" />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
  </svg>
);

export const ButtonLoader = ({
  stroke = "#AEB6BF",
  fillStroke = "#fff",
  wrapperClass = "",
  containerClass = "",
}) => (
  <div className={`loader-wrapper ${wrapperClass}`}>
    <div className={`button-loader ${containerClass}`}>
      <svg
        version="1.1"
        id="L4"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 115 16"
        enableBackground="new 0 0 0 0"
        stroke={stroke}
      >
        <circle fill={fillStroke} stroke="none" cx="6" cy="10" r="5">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle fill={fillStroke} stroke="none" cx="26" cy="10" r="5">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
        <circle fill={fillStroke} stroke="none" cx="46" cy="10" r="5">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
        <circle fill={fillStroke} stroke="none" cx="66" cy="10" r="5">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.4"
          />
        </circle>
        <circle fill={fillStroke} stroke="none" cx="86" cy="10" r="5">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.5"
          />
        </circle>
        <circle fill={fillStroke} stroke="none" cx="106" cy="10" r="5">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.6"
          />
        </circle>
      </svg>
    </div>
  </div>
);

export const BSpinner = ({ className = "" }) => (
  <div className={`spinner-border ${className}`} role="status">
    <span className="sr-only">Loading...</span>
  </div>
);

export const Dot = ({ className = "" }) => (
  <div className={`spinner-grow ${className}`} role="status">
    <span className="sr-only">Loading...</span>
  </div>
);

export const ThreeDots = ({ className = "", dotClass = "" }) => (
  <div className={className}>
    {[...Array(3)].map((_, idx) => (
      <Dot key={`dot-${idx}`} className={`${dotClass} mr-2`} />
    ))}
  </div>
);

export const PageLoader = ({
  wrapperClass = "",
  containerClass = "",
  }) => (
  <div className={`d-flex align-items-center justify-content-center min-h-100vh ${wrapperClass}`}>
    <Spinner />
  </div>
);

export const ThreeProgressiveDots = ({ className = "", dotClass = "" }) => (
  <div className={`${className} loader-wrapper`}>
    {[...Array(3)].map((_, idx) => (
      <div key={`dot-${idx}`} className={`${dotClass} dot dot${idx + 1} `} />
    ))}
  </div>
);

export default { Spinner, BSpinner, Dot, ThreeDots, PageLoader, ThreeProgressiveDots };
